import React from 'react'
import PropTypes from 'prop-types'

import { useAuthStore } from '../../store/auth'
import { useGetMutateCall } from '../../lib/api/get'
import { useCreateCall } from '../../lib/api/create'
import { NoDataCard } from '../../common/NoDataCard'
import { Apps } from './apps'

import selectDown from '../../assets/images/select-down.svg'

export const Organizations = ({
  isLocalEnvironment,
  setActiveOrgRoutes,
  authDetails,
  activeOrgRoutes,
  isDefaultOrg,
  setIsDefaultOrg,
  defaultApp,
  setApp,
  setDefaultApp,
  routeData,
}) => {
  const moduleSchema =
    routeData.apiEndPointSchema !== '' || routeData.apiEndPointSchema !== null
      ? JSON.parse(routeData.apiEndPointSchema)
      : null
  const [organizationsData, setOrganizationsData] = React.useState(null)
  const [searchKey, setSearchKey] = React.useState(null)
  const [filtersKey, setFiltersKey] = React.useState({})
  const [sortKey, setSortKey] = React.useState(null)
  const [orderKey, setOrderKey] = React.useState(null)
  const [pageKey, setPageKey] = React.useState(1)
  const getCallMutation = useGetMutateCall()
  const createCallMutation = useCreateCall()
  const { setOrgRole, setAuthentication } = useAuthStore()

  const getAllOrgs = async () => {
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'allApps',
        params: `&page=1&limit=10${moduleSchema?.moduleAddParam ? moduleSchema.moduleAddParamString : ''}`,
      })
      .then((resp) => setOrganizationsData(resp.formData))
  }
  React.useEffect(() => {
    getAllOrgs()
  }, [])

  // const setApp = (app) => {
  //   sessionStorage.removeItem('defApp')
  //   setDefaultApp(app)
  //   sessionStorage.setItem('defApp', JSON.stringify(app))
  //   setActiveOrg(app.orgName)
  //   getCallMutation
  //     .mutateAsync({
  //       apiURL: isLocalEnvironment + '/getData',
  //       apiEndpoint: 'orgAppData',
  //       params: `&targetTenantId=${app.tenantId}&targetAppId=${app.appId}&targetOrgId=${app.orgId}`,
  //     })
  //     .then((resp) => {
  //       sessionStorage.setItem(
  //         'activeRoutes',
  //         JSON.stringify({
  //           formData: { Pages: resp.formData.pageData, orgRoles: resp.formData.userRoles },
  //         }),
  //       )
  //       setActiveOrgRoutes({
  //         formData: { Pages: resp.formData.pageData, orgRoles: resp.formData.userRoles },
  //       })

  //       const orgRoleDetails = resp.formData.userRoles.filter((f) => f.isDefault === 1)
  //       setOrgRole(orgRoleDetails[0].rowFormData.roleName, orgRoleDetails[0].rowFormData.roleId)
  //       setAuthentication({
  //         ...authDetails,
  //         resObject: authDetails.authentication,
  //         orgRoleId: orgRoleDetails[0].rowFormData.roleId,
  //         orgRole: orgRoleDetails[0].rowFormData.roleName,
  //       })
  //       //console.log(activeOrgRoutes)
  //       //window.location.href = '/organization/dashboard'
  //     })
  // }

  //console.log(activeOrgRoutes)
  const signUpToOrg = async () => {
    const allRoles = sessionStorage.getItem('auth')
      ? JSON.parse(sessionStorage.getItem('auth'))
      : null
    const role = allRoles.state.dependeciesFormAPIS?.role?.formData?.filter(
      (f) => f.roleName === 'AppUser',
    )

    const data = {
      appId: defaultApp.appId,
      tenantId: defaultApp.tenantId,
      orgId: defaultApp.orgId,
      roleId: role[0].roleId,
      userId: authDetails.session.userId,
      isDefault: 1,
    }
    await createCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/addData',
        apiEndpoint: 'userRole/userSignUp',
        data: data,
        messageTitle: 'Sign-Up',
        message: 'Sign-up successfull!',
        isDynamic: true,
        params: '',
      })
      .then(() => {
        getCallMutation
          .mutateAsync({
            apiURL: isLocalEnvironment + '/getData',
            apiEndpoint: 'orgAppData',
            params: `&targetTenantId=${defaultApp.tenantId}&targetAppId=${defaultApp.appId}&targetOrgId=${defaultApp.orgId}`,
          })
          .then((resp) => {
            sessionStorage.setItem(
              'activeRoutes',
              JSON.stringify({
                formData: { Pages: resp.formData.pageData, orgRoles: resp.formData.userRoles },
              }),
            )
            setActiveOrgRoutes({
              formData: { Pages: resp.formData.pageData, orgRoles: resp.formData.userRoles },
            })

            const orgRoleDetails = resp.formData.userRoles.filter((f) => f.isDefault === 1)
            setOrgRole(orgRoleDetails[0].rowFormData.roleName, orgRoleDetails[0].rowFormData.roleId)
            setAuthentication({
              ...authDetails,
              resObject: authDetails.authentication,
              orgRoleId: orgRoleDetails[0].rowFormData.roleId,
              orgRole: orgRoleDetails[0].rowFormData.roleName,
            })
          })
      })
  }

  const setFilter = (val, typ) => {
    if (typ === 'state') {
      setFiltersKey({ ...filtersKey, orgProvince: val })
    } else {
      setFiltersKey({ ...filtersKey, orgCity: val })
    }
  }

  const applySearch = async (e) => {
    e.preventDefault()
    let urlParam = ''
    if (searchKey !== null) {
      urlParam = urlParam + '&search=' + searchKey
    }
    if (filtersKey.orgProvince || filtersKey.orgCity) {
      urlParam = urlParam + '&filters=' + JSON.stringify(filtersKey)
    }
    if (sortKey !== null) {
      urlParam = urlParam + '&sortOrder=' + sortKey
    }
    if (orderKey !== null) {
      urlParam = urlParam + '&sortBy=' + orderKey
    }

    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'allApps',
        params: urlParam + '&page=' + pageKey,
      })
      .then((resp) => setOrganizationsData(resp.formData))
  }

  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false

  return (
    <>
      {getCallMutation.isLoading ? (
        <div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '20%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <React.Fragment key={isLayoutDark}>
          <div className="trtui-row">
            <div className="trtui-col-lg-12">
              <div className="trtui-card" id="customerList">
                <div className="trtui-card-header trtui-border-bottom-dashed">
                  <div className="trtui-row trtui-g-4 trtui-align-items-center">
                    <div className="trtui-col-sm-auto">
                      <div className="trtui-d-flex trtui-flex-wrap trtui-align-items-start trtui-gap-2">
                        <button className="trtui-btn trtui-btn-soft-danger" id="remove-actions">
                          <i className="ri-delete-bin-2-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="trtui-card-body trtui-border-bottom-dashed trtui-border-bottom">
                  <form onSubmit={(e) => applySearch(e)}>
                    <div className="trtui-row trtui-g-3">
                      <div className="trtui-col-xl-4">
                        <div className="trtui-search-box">
                          <input
                            type="text"
                            className="trtui-form-control trtui-search"
                            placeholder="Search for child care, email, phone, status or something..."
                            onChange={(e) => setSearchKey(e.target.value)}
                            defaultValue={searchKey}
                          />
                          <i className="ri-search-line trtui-search-icon" />
                        </div>
                      </div>
                      <div className="trtui-col-xl-7">
                        <div className="trtui-row trtui-g-3">
                          <div className="trtui-col-sm-3">
                            <div className>
                              <select
                                className="trtui-form-select trtui-text-muted"
                                style={{
                                  '--vz-form-select-bg-img': `url("${selectDown}")`,
                                }}
                                onChange={(e) => setFilter(e.target.value, 'state')}
                                defaultValue={filtersKey.orgProvince}
                              >
                                <option value={''}>Filter By State</option>
                                {organizationsData?.map((opt, optInd) => (
                                  <option
                                    key={optInd}
                                    value={opt.orgProvince}
                                    selected={filtersKey.orgProvince === opt.orgProvince}
                                  >
                                    {opt.orgProvince}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="trtui-col-sm-3">
                            <select
                              className="trtui-form-select trtui-text-muted"
                              style={{
                                '--vz-form-select-bg-img': `url("${selectDown}")`,
                              }}
                              onChange={(e) => setFilter(e.target.value, 'city')}
                              defaultValue={filtersKey.orgCity}
                            >
                              <option value={''}>Filter By City</option>
                              {organizationsData?.map((opt, optInd) => (
                                <option
                                  key={optInd}
                                  value={opt.orgCity}
                                  selected={filtersKey.orgCity === opt.orgCity}
                                >
                                  {opt.orgCity}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="trtui-col-sm-3">
                            <select
                              className="trtui-form-select trtui-text-muted"
                              style={{
                                '--vz-form-select-bg-img': `url("${selectDown}")`,
                              }}
                              onChange={(e) => setOrderKey(e.target.value)}
                            >
                              <option value={''}>Order By</option>
                              <option value="orgName" selected={orderKey === 'orgName'}>
                                Name
                              </option>
                              <option value="orgProvince" selected={orderKey === 'orgProvince'}>
                                State
                              </option>
                              <option value="orgCity" selected={orderKey === 'orgCity'}>
                                City
                              </option>
                            </select>
                          </div>
                          <div className="trtui-col-sm-3">
                            <select
                              className="trtui-form-select trtui-text-muted"
                              style={{
                                '--vz-form-select-bg-img': `url("${selectDown}")`,
                              }}
                              onChange={(e) => setSortKey(e.target.value)}
                            >
                              <option value={''}>Sort By</option>
                              <option value="ASC" selected={sortKey === 'ASC'}>
                                Ascending
                              </option>
                              <option value="DESC" selected={sortKey === 'DESC'}>
                                Descending
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="trtui-col-sm-1">
                        <button className="trtui-btn trtui-btn-primary" type="submit">
                          Apply
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div key={`${defaultApp}${organizationsData}`} className="trtui-col-12">
            {organizationsData === null && (
              <NoDataCard
                key={isLayoutDark}
                isLayoutDark={isLayoutDark}
                schemaNotConfigured={true}
              />
            )}
            {organizationsData?.length <= 0 ? (
              <div className="trtui-col-12 trtui-project-card">
                <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} />
              </div>
            ) : (
              <div>
                {activeOrgRoutes !== null && activeOrgRoutes.formData?.orgRoles?.length <= 0 && (
                  <div
                    className="trtui-alert trtui-alert-danger trtui-alert-additional trtui-fade trtui-show trtui-mb-3"
                    role="alert"
                  >
                    <div className="trtui-alert-body">
                      <div className="trtui-d-flex">
                        <div className="trtui-flex-shrink-0 trtui-me-3">
                          <i className="ri-alert-line trtui-fs-16 trtui-align-middle"></i>
                        </div>
                        <div className="trtui-flex-grow-1">
                          <h5 className="trtui-alert-heading">
                            You are not associated with this organization! Click on sign up button
                            to sign up to this oraganization.
                          </h5>
                          <p className="trtui-mb-0">
                            <button
                              type="button"
                              className="trtui-btn trtui-btn-outline-danger trtui-btn-label trtui-waves-effect trtui-waves-light"
                              onClick={signUpToOrg}
                            >
                              <i className="ri-user-add-line trtui-label-icon trtui-align-middle trtui-fs-16 trtui-me-2"></i>{' '}
                              Sign up
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="trtui-row">
                  {organizationsData?.map((app, appInd) => (
                    <Apps
                      key={`${appInd}${isDefaultOrg}`}
                      appsData={app}
                      defaultApp={defaultApp}
                      setApp={setApp}
                      setPageKey={setPageKey}
                      isLocalEnvironment={isLocalEnvironment}
                      authDetails={authDetails}
                      setIsDefaultOrg={setIsDefaultOrg}
                      isDefaultOrg={isDefaultOrg}
                      setDefaultApp={setDefaultApp}
                      activeOrgRoutes={activeOrgRoutes}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </>
  )
}

Organizations.propTypes = {
  isLocalEnvironment: PropTypes.string,
  setActiveOrgRoutes: PropTypes.func,
  authDetails: PropTypes.object,
  activeOrgRoutes: PropTypes.object,
  isDefaultOrg: PropTypes.object,
  setIsDefaultOrg: PropTypes.func,
  defaultApp: PropTypes.object,
  setApp: PropTypes.func,
  setDefaultApp: PropTypes.func,
  routeData: PropTypes.object,
}
